<<template>
  <div>
    <el-dropdown-item v-for="item in actionList" :key="item.index" @click.native=setAction(item)>
      {{ item.name }}
    </el-dropdown-item>
  </div>
</template>

  <script>
  export default {
    data() {
      return {
        actionList: [
          { name: '百度搜索', type: 'url', url: 'http://www.baidu.com' }
        ]
      }
    },
    methods: {
      setAction(item) {
        if (item.type === 'url') {
          window.open(item.url)
        }
      }
    },
  }
</script>

  <style lang="scss" scoped></style>